module.exports = __webpack_public_path__ + "static/img/gold.497ff79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gold.jpg
// module id = x9Wv
// module chunks = 1